import { FileAccessProviders } from '~/@types/interface';
import { StaticImageData } from 'next/image';

import airtableLogo from '../../public/airtable.png';
import airtableSquaredLogo from '../../public/airtable-squared.png';
import googleDocLogo from '../../public/doc.png';
import googleSheetsSquaredLogo from '../../public/google-sheets-squared.png';
import csvSquaredLogo from '../../public/csv-squared.png';
import frameIOLogo from '../../public/frame-io.png';
import figmaLogo from '../../public/figma-squared.png';
import { IntegrationProvider } from '@prisma/client';

/** Crisp vector mark — shared by catalog cards + connect modal. */
const SHAREPOINT_MARK = '/sharepoint-squared.svg';

export const getProviderText = (provider: FileAccessProviders) => {
  const stringMap: Record<FileAccessProviders, string> = {
    AIRTABLE: 'Airtable',
    GOOGLE_APIS: 'Google Workspace',
    SHAREPOINT: 'SharePoint',
    FRAMEIO: 'Frame.io',
    FIGMA: 'Figma',
  };
  return stringMap[provider];
};

export const getProviderImage = (provider: FileAccessProviders) => {
  if (provider === 'SHAREPOINT') return SHAREPOINT_MARK;

  const images: Record<Exclude<FileAccessProviders, 'SHAREPOINT'>, StaticImageData> = {
    AIRTABLE: airtableLogo,
    GOOGLE_APIS: googleDocLogo,
    FRAMEIO: frameIOLogo,
    FIGMA: figmaLogo,
  };
  return images[provider].src;
};

export const getProviderImageForTable = (provider: IntegrationProvider) => {
  if (provider === 'SHAREPOINT') return SHAREPOINT_MARK;

  const images: Record<Exclude<IntegrationProvider, 'SHAREPOINT'>, StaticImageData> = {
    AIRTABLE: airtableSquaredLogo,
    GOOGLE_APIS: googleSheetsSquaredLogo,
    FIGMA: figmaLogo,
    // placeholder for provider logos
    FRAMEIO: csvSquaredLogo,
    ASANA: csvSquaredLogo,
    JIRA: csvSquaredLogo,
    SMARTSHEET: csvSquaredLogo,
    WRIKE: csvSquaredLogo,
  };
  return images[provider].src;
};

export const getProviderRoles = (provider: FileAccessProviders) => {
  const map: Record<FileAccessProviders, string[]> = {
    AIRTABLE: ['Attribute Database'],
    FRAMEIO: ['Task Manager Files'],
    GOOGLE_APIS: ['Task Manager Files', 'Attribute Database'],
    SHAREPOINT: ['Task Manager Files'],
    FIGMA: ['Task Manager Files'],
  };
  return map[provider];
};

export const shouldProviderSyncTasks = (provider: FileAccessProviders) => {
  const map: Record<FileAccessProviders, boolean> = {
    AIRTABLE: false,
    FRAMEIO: true,
    GOOGLE_APIS: true,
    SHAREPOINT: true,
    FIGMA: false,
  };
  return map[provider];
};
